/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export { default as CollectionDiscoveryContext } from './components/CollectionDiscoveryContext';
export { default as CollectionSelectionConfirmationPage } from './components/CollectionSelectionConfirmationPage';
export { default as PresetCollectionPage } from './components/PresetCollectionPage';
export { default as CollectionCategoryPage } from './components/CollectionCategoryPage';
export { default as TaggedCollectionsPage } from './components/TaggedCollectionsPage';
export { default as CollectionDiscoveryPage } from './components/CollectionDiscoveryPage';
export const LearningPathLibraryDynamic = () => import('./components/LearningPathLibrary');
export const CollectionDiscoveryContextDynamic = () => import('./components/CollectionDiscoveryContext');
export const CollectionSelectionConfirmationPageDynamic = () =>
  import('./components/CollectionSelectionConfirmationPage');
export const PresetCollectionPageDynamic = () => import('./components/PresetCollectionPage');
export const CollectionCategoryPageDynamic = () => import('./components/CollectionCategoryPage');
export const TaggedCollectionsPageDynamic = () => import('./components/TaggedCollectionsPage');
export const CollectionDiscoveryPageDynamic = () => import('./components/CollectionDiscoveryPage');
export const LearningPathLibraryContextDynamic = () => import('./components/context/LearningPathLibraryContext');
export const LearningPathLibraryBadgePageDynamic = () => import('./components/LearningPathLibraryBadgePage');
export const CollectionLibraryPageDynamic = () => import('./components/CollectionLibraryPage');

/**
 *  #################################### Generated content ####################################
 **/
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/enterprise-admin-program-catalog/components/catalog/ProgramCollectionsPage.tsx
 * @link file://./../../bundles/enterprise-admin-program-catalog/components/catalog/ProgramLearningPathsPage.tsx
 */
export { useContractTagNames, useContractsByIds, useEnableCentralizedContentLibrary } from './hooks';

/**
 *  #################################### Generated content ####################################
 **/
